import React, {Component} from 'react';
import {connect} from 'react-redux';

class NotFound extends Component {
  constructor(props) {
    super(props);

    props.setTitle(null);
  }

  render() {
    return (
      <div>
        <h1>Not Found</h1>        
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  setTitle: title => dispatch({type: 'SET_TITLE', payload: title})
});

export default connect(null, mapDispatchToProps)(NotFound);
